import React, { useState } from "react"
import { Link } from "gatsby"
import SideBarMenu from "../sidebar/sidebar"
import { Dropdown } from "react-bootstrap"
import HorizontalMenu from "../sidebar/horizontalmenu"
import Sticky from "react-sticky-el"
import { stickyWrapper, isSticky, header } from "./header.module.css"
// const mapSizesToProps = ({ width }) => ({
//   isMobile: width < 991,
// })
// import "./header.css"

import { StaticImage } from "gatsby-plugin-image"

class Header extends React.Component {
  // componentDidMount() {
  //   if (window) {
  //     var prevScrollpos = window.pageYOffset
  //     var menu = document.getElementById("nav-menu")
  //     if (menu) {
  //       window.onscroll = function() {
  //         var currentScrollPos = window.pageYOffset
  //         if (prevScrollpos > currentScrollPos) {
  //           if (menu.classList.contains("sticky-on")) {
  //             menu.classList.remove("sticky-on")
  //             menu.style.top = "0"
  //           } else {
  //             console.log("not exist")
  //           }
  //         } else {
  //           menu.classList.add("sticky-on")
  //           menu.style.top = "-94px"
  //         }
  //         prevScrollpos = currentScrollPos
  //       }
  //     } else {
  //       console.log("no exist")
  //     }
  //   }
  // }
  constructor() {
    super()
    this.state = {
      show: true,
      scrollPos: 0,
    }
  }
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll)
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll)
  }
  handleScroll = () => {
    this.setState({
      scrollPos: document.body.getBoundingClientRect().top,
      show: document.body.getBoundingClientRect().top > this.state.scrollPos,
    })
  }

  render() {
    return (
      <header>
        <div id="navigation">
          <nav className={`${this.state.show ? "active" : "d-active"}`}>
            <div
              id="nav-menu"
              className="menu-container"
              style={{ boxShadow: "0px 3px 6px #00000029" }}
            >
              <div className="container-fluid sub-heading d-none d-lg-block">
                <div className="row d-none d-lg-flex align-items-center">
                  <div className="col-lg-4">
                    <div className="d-flex">
                      <a
                        href="https://www.instagram.com/FLUOFeelAlive/"
                        target="_blank"
                      >
                        <StaticImage
                          width={20}
                          height={20}
                          layout="fixed"
                          src="../../images/social-logos/insta.png"
                          className="mx-2"
                        />
                      </a>
                      <a
                        href="https://www.facebook.com/FLUOFeelAlive/"
                        target="_blank"
                      >
                        <StaticImage
                          width={20}
                          height={20}
                          layout="fixed"
                          src="../../images/social-logos/fb.png"
                          className="mx-2"
                        />
                      </a>
                      <a
                        href="https://www.youtube.com/channel/UCbXUCc-pw5mIo5dNoTB0qoQ"
                        target="_blank"
                      >
                        <StaticImage
                          width={20}
                          height={20}
                          layout="fixed"
                          src="../../images/social-logos/yt.png"
                          className="mx-2"
                        />
                      </a>
                      <a
                        href="https://www.linkedin.com/company/fluofeelalive/"
                        target="_blank"
                      >
                        <StaticImage
                          width={20}
                          height={20}
                          layout="fixed"
                          src="../../images/social-logos/ln.png"
                          className="mx-2"
                        />
                      </a>
                    </div>
                  </div>
                  <div className="col-lg-4 text-center">
                    <small>
                      Free Shipping on Orders over $150{" "}
                      <a href="/shipping-policy">* Details</a>
                    </small>
                  </div>
                  <div className="col-lg-4 d-flex justify-content-end">
                    <Dropdown className="customer-care">
                      <Dropdown.Toggle variant="success" id="dropdown">
                        Customer Care
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item href="tel:13038353535">
                          +1 (303) 835-3535
                        </Dropdown.Item>

                        <Dropdown.Item href="/support-center/#support-navs">
                          Support Center
                        </Dropdown.Item>
                        <Dropdown.Item href="/support-center/#support-navs">
                          Contact Us
                        </Dropdown.Item>
                        <Dropdown.Item href="/app/login">
                          Your Order
                        </Dropdown.Item>
                        <Dropdown.Item href="/support-center/#support-navs">
                          Shipping & Information
                        </Dropdown.Item>
                        <Dropdown.Item href="/support-center/#support-navs">
                          Returns & Exchanges
                        </Dropdown.Item>
                        {/* <Dropdown.Item href="/">
                          International Shipping
                        </Dropdown.Item>
                        <Dropdown.Item href="/">
                          International Returns
                        </Dropdown.Item>
                        <Dropdown.Item href="/support-center/">
                          FAQs
                        </Dropdown.Item> */}
                        <Dropdown.Item href="/support-center/">
                          Gift Cards
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>
              <div className="bottom-nav">
                <div className="container-fluid">
                  <div className="row d-flex align-items-center">
                    <div className="col-9 col-md-3">
                      <div className="nav-brand d-flex align-items-center">
                        <Link
                          aria-label="link"
                          to="/"
                          className="header-logo mr-3"
                        >
                          <StaticImage
                            placeholder="blurred"
                            imgClassName="img-fluid"
                            src="../../images/header-logo.png"
                            alt="logo"
                            layout="constrained"
                          />
                        </Link>
                        <div class="menu-wrap">
                          <ul class="menu">
                            <li class="menu-item">
                              <a href="/inside-fluo/" className="logo-dropdown">
                                Inside Fluo
                              </a>
                              <ul class="drop-menu">
                                <li class="drop-menu-item">
                                  <a href="/rally/" className="rally">
                                    <span className="cta-title">
                                      we’re here to rally
                                    </span>
                                  </a>
                                </li>
                                <li class="drop-menu-item">
                                  <a href="/belief/" className="beliefs">
                                    <span className="cta-title">
                                      our beliefs
                                    </span>
                                  </a>
                                </li>
                                <li class="drop-menu-item">
                                  <a href="/why-fluo/" className="fluo">
                                    <span className="cta-title">
                                      why fluo foundation?
                                    </span>
                                  </a>
                                </li>
                                <li class="drop-menu-item">
                                  <a
                                    href="/stewardship/"
                                    className="stewardship"
                                  >
                                    <span className="cta-title">
                                      consciousness & Stewardship
                                    </span>
                                  </a>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-2 col-md-6 ml-auto">
                      <div className="d-none d-lg-inline d-lg-flex justify-content-center">
                        <HorizontalMenu />
                      </div>
                      <div className="d-inline d-lg-none d-md-none">
                        <SideBarMenu />
                      </div>
                    </div>
                    <div className="col-9 col-md-3">
                      <div className="d-none d-md-flex justify-content-end align-items-center">
                        <a href="#">
                          <StaticImage
                            width={20}
                            height={20}
                            layout="fixed"
                            src="../../images/header-util/lang.png"
                            className="mx-2"
                          />
                        </a>
                        <Dropdown>
                          <Dropdown.Toggle
                            as={CustomToggle}
                            id="dropdown-basic"
                          >
                            <StaticImage
                              width={20}
                              height={20}
                              layout="fixed"
                              src="../../images/header-util/user.png"
                              className="mx-2"
                            />
                          </Dropdown.Toggle>

                          {this.props?.value?.customer ? (
                            <Dropdown.Menu>
                              <Dropdown.Item
                                href="/app/account"
                                className="text-dark"
                              >
                                My Account
                              </Dropdown.Item>
                              <Dropdown.Item
                                href="#"
                                className="text-dark"
                                onClick={() =>
                                  this.props.value.signoutCustomer()
                                }
                              >
                                Logout
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          ) : (
                            <Dropdown.Menu>
                              <Dropdown.Item
                                href="/app/login"
                                className="text-dark"
                              >
                                Sign In
                              </Dropdown.Item>
                              <Dropdown.Item
                                href="/app/register"
                                className="text-dark"
                              >
                                Sign Up
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          )}
                        </Dropdown>
                        {/* <a href="#">
                          <StaticImage
                            width={20}
                            height={20}
                            layout="fixed"
                            src="../../images/header-util/search.png"
                            className="mx-2"
                          />
                        </a> */}
                        <a
                          href="/cart"
                          style={{ position: "relative" }}
                          className="cart"
                        >
                          <span
                            class="badge badge-secondary"
                            style={{
                              position: "absolute",
                              top: -12,
                              right: -2,
                              zIndex: 1,
                            }}
                          >
                            {this.props.cart_value?.state?.cart?.numberItems ||
                              0}
                          </span>

                          <StaticImage
                            width={20}
                            height={20}
                            layout="fixed"
                            src="../../images/header-util/cart.png"
                            className="mx-2"
                          />
                        </a>

                        <div className="d-inline d-lg-none">
                          <SideBarMenu />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </header>
    )
  }
}

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <a
    href=""
    ref={ref}
    onClick={e => {
      e.preventDefault()
      onClick(e)
    }}
  >
    {children}
  </a>
))

export default Header
